import { MobileRefreshButton } from "./MobileRefreshButton";

// Titles and the refresh control live in the page flow. Search is the glass
// pill in MobileTopBar, which is the only search entry on a phone.
const MobileHeader = ({
  children,
  showRefresh = false,
}: {
  children: React.ReactNode;
  showRefresh?: boolean;
}) => {
  return (
    <div
      data-mobile-header
      className="sticky top-[var(--mobile-content-top)] z-30 mb-3 flex items-center gap-2 bg-background/85 px-4 py-1.5 backdrop-blur-md"
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">{children}</div>
      {showRefresh ? <MobileRefreshButton /> : null}
    </div>
  );
};

export default MobileHeader;
